module.exports = __webpack_public_path__ + "media/src/images/icons/flags/russia-2d41de286a185dd6e26c03e6270f8876.svg";